<template>
  <div class="organ_device_item-bd ubv">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_organ_device_item.jshModemSNjqmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('base_organ_device_item.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_item.zu_zhi_ming_cheng')">
          <custom-select
            style="display: inline-block; width: 98px; margin-right: 2px"
            @clear="formSearch.orgName = ''"
            v-model="formSearch.orgType"
            code="bas_org_type"
            :props="{ label: 'name', value: 'value' }"
            :placeholder="$t('base_organ_device_item.zu_zhi_lei_xing')"
            width="100%"
          ></custom-select>
          <el-input :disabled="!formSearch.orgType" v-model="formSearch.orgName" style="width: calc(100% - 100px)"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_item.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('base_organ_device_item.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        :index="true"
        tableCode="organ_device"
        :type="orgBy === 'groupCustomer' ? 'checkbox' : undefined"
        selectableKey="selectableKey"
        v-model="selectedData"
        :data="deviceList"
        @column="setColumn"
        @filter="filterChange"
        @sort="sortChange"
        height="100%"
      >
        <el-table-column :label="$t('Common.com_handle')" fixed="right" min-width="220">
          <template slot-scope="scope">
            <el-button v-if="funcView.organ_device_bind_update || !!orgId" type="text" size="mini" @click="editOrganDevice(scope.row)">
              {{ $t('base_organ_device_item.fen_pei') }}
            </el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <organ-device-dialog v-if="dialogVisible" :model="dialogModel" @success="onPageChange({ page: 1 })" @close="dialogVisible = false"></organ-device-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import organDeviceDialog from './organ_device_dialog.vue';

export default {
  mixins: [resetFormSearchMixins],
  components: { organDeviceDialog },
  props: {
    orgId: [String, Number],
    orgBy: [String],
    organ: {
      type: Object,
      default() {
        return {};
      },
    },
    user: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},

      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        bizId: '',
        bizType: '',
        parentId: '',
        isAss: 1,
        pageSize: 20,
        pageNum: 1,
        productCode: '',
        orgType: '',
        orgName: '',
        locationName: '',
        contractNo: '',
      },
      selectedData: [],
      deviceList: [],
      totalRows: 0,
    };
  },
  watch: {
    organ: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.deviceList = [];
      this.totalRows = 0;
      this.getOrganDevice();
    },
    user: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.deviceList = [];
      this.totalRows = 0;
      this.getOrganDevice();
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView('/company/organdevice');
    this.getOrganDevice();
  },
  methods: {
    // 组织设备
    getOrganDevice: function () {
      if (!this.organ.bizId) {
        return;
      }
      this.formSearch.bizId = this.user && this.user.bizId ? this.user.bizId : this.organ.bizId;
      this.formSearch.bizType = this.user && this.user.bizId ? this.user.bizType : this.organ.bizType;
      this.formSearch.parentId = this.organ.orgId;
      this.$getJSON(apis.BizDevicePage, this.formSearch).then((res) => {
        const list = res.data.list || [];
        list.forEach((item) => {
          item.selectableKey = `${item.isAuto}` === '1';
        });
        this.deviceList = list;
        this.totalRows = res.data.total;
      });
    },
    // 编辑部门设备
    editOrganDevice: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_organ_device_item.jjqtjgbmyh');
      this.dialogModel.data = { ...data, orgId: this.orgId };
      this.dialogVisible = true;
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getOrganDevice();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.organ_device_item-bd {
  height: 100%;
}
</style>
